import { objectSelector } from 'theme/utils';
import { request } from '../axios/request';

import {
  FETCH_TRANSFER_STATUS_LIST_PENDING,
  FETCH_TRANSFER_STATUS_LIST_REJECTED,
  FETCH_TRANSFER_STATUS_LIST_FULFILLED,
} from '../constants/transferStatuses';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_TRANSFER_STATUS_LIST_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_TRANSFER_STATUS_LIST_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: FETCH_TRANSFER_STATUS_LIST_REJECTED,
  error,
});

export const fetchTransferStatuses = () => (dispatch) => {
  const responseLanguage = objectSelector($A, 'RESPONSE_LANGUAGE', 'en-us');
  dispatch(pending());

  request({
    method: 'get',
    url: OMS.OMS.TRANSFER_STATUS_LIST,
    headers: {
      'accept-language': responseLanguage,
    },
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/transferStatuses.js